import CertificateBackground from '../../../Visuals/Images/Certificate.png';
import jsPDF from 'jspdf';
import { compressPDF } from './compressPDF'; // Import the compressPDF function

// Generates the certificate blob to send to the server
export const generateCertBlob = async (
  name,
  course,
  dateCompleted,
  expiryDate,
  certNumber
) => {
  try {
    // Generate the PDF with jsPDF
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'in',
      format: [8, 11],
    });

    doc.addImage(
      CertificateBackground,
      'PNG',
      0,
      0,
      doc.internal.pageSize.getWidth(),
      doc.internal.pageSize.getHeight()
    );
    doc.setFontSize(36);
    doc.setFont('helvetica');
    doc.text(name, 5.5, 4.4, { align: 'center' });
    doc.setFontSize(20);
    doc.text(course, 5.5, 5.5, { align: 'center' });
    doc.setFontSize(12);
    doc.text(dateCompleted, 2.4, 6.3);
    doc.text(expiryDate, 6.7, 6.3);
    doc.text(certNumber, 6.7, 7.2);

    const pdfBlob = doc.output('blob');
    const compressedBlob = await compressPDF(pdfBlob);
    return compressedBlob;
  } catch (err) {
    console.error('Error generating or compressing PDF:', err);
    throw err;
  }
};
